import { MutableRefObject, useEffect, useRef } from 'react';

interface IOptions {
  ignore?: MutableRefObject<any>[];
  stopPropagation?: boolean;
}

const useOffClick = (
  onOffClick: (event: MouseEvent) => void,
  options: IOptions = {},
) => {
  const { ignore = [], stopPropagation = false } = options;
  const ref = useRef<any>(null);
  const savedIgnoreElRef = useRef<MutableRefObject<any>[]>(ignore);
  const savedOffClickHandler = useRef(onOffClick);

  const handleClickOutside = (e: MouseEvent) => {
    if (
      ref.current &&
      !ref.current.contains(e.target) &&
      savedIgnoreElRef.current.every(el => !el.current.contains(e.target))
    ) {
      if (stopPropagation) e.stopPropagation();
      savedOffClickHandler.current(e);
    }
  };

  useEffect(() => {
    savedIgnoreElRef.current = ignore;
  });

  useEffect(() => {
    savedOffClickHandler.current = onOffClick;
  });

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  }, []);

  return ref;
};

export default useOffClick;
